import React from 'react'
import PlayerAvatar from './PlayerAvatar'

export interface TeamResultProps {
  /** Jogadores da equipe */
  players: { nome: string; imagemUrl?: string | null }[]
  /** Resultado da equipe */
  result?: 'win' | 'loss' | 'pending'
}

const TeamResult: React.FC<TeamResultProps> = ({ players, result }) => {
  const color = result === 'win' ? 'text-primary' : result === 'loss' ? 'text-danger' : ''
  const label = result === 'win' ? 'Vitória' : result === 'loss' ? 'Derrota' : ''
  return (
    <div className="text-center">
      {label && <div className={`fw-bold mb-1 ${color}`}>{label}</div>}
      <div className="d-flex justify-content-center gap-2">
        {players.map((p, i) => (
          <PlayerAvatar key={i} name={p.nome} imageUrl={p.imagemUrl} />
        ))}
      </div>
    </div>
  )
}

export default TeamResult
